import lessonNumberSvg from '../assets/print/lesson-number.svg'
import { LAYOUT, BLEED_SIZE_MM, mmToPx } from './constants'

const BLEED_CROP = mmToPx(BLEED_SIZE_MM) // 11px — 도련 없을 때 좌측·상단 잘라낼 양

export function ChapterNumber({ number, bleedPx = 0 }: { number: string; bleedPx?: number }) {
  const hasBleed = bleedPx > 0
  const crop = hasBleed ? 0 : BLEED_CROP
  const w = LAYOUT.chapterNumber.width - crop
  const h = LAYOUT.chapterNumber.height - crop

  return (
    <div
      className="absolute top-0 left-0"
      style={{ width: w, height: h, overflow: 'hidden', zIndex: 1 }}
    >
      <img
        src={lessonNumberSvg}
        alt=""
        width={LAYOUT.chapterNumber.width}
        height={LAYOUT.chapterNumber.height}
        style={hasBleed ? undefined : { marginLeft: -BLEED_CROP, marginTop: -BLEED_CROP }}
      />
      {/* Chapter number overlay */}
      <span
        className="absolute text-white font-dunggeunmiso"
        style={{
          top: LAYOUT.chapterNumber.numberTop - crop,
          left: LAYOUT.chapterNumber.numberLeft - crop,
          fontSize: LAYOUT.chapterNumber.fontSize,
          fontWeight: 700,
          letterSpacing: '3.2px',
          lineHeight: 1,
          textAlign: 'center',
        }}
      >
        {number}
      </span>
    </div>
  )
}
